<template>
    <div class="root">
        <div class="backdrop" v-if="opened" @click="toggle"></div>
        <div class="dropdown" :class="{ 'is-active': opened }">
            <div class="dropdown-trigger">
                <button
                    class="button dropdown-button"
                    aria-haspopup="true"
                    @click="toggle"
                    aria-controls="dropdown-menu"
                >
                    <div class="selected-driver">
                        <div class="selected-driver-part">
                            <span class="selected-driver-label">Courier</span>
                            <span class="selected-courier-value is-size-7">{{
                                selectedCourierName
                            }}</span>
                        </div>
                        <div class="selected-driver-part">
                            <span class="selected-driver-label">Driver</span>
                            <span class="is-size-7">{{ driverName }}</span>
                        </div>
                    </div>
                    <span class="icon is-small">
                        <i
                            v-if="!opened && status === 'COMPLETED'"
                            class="fas fa-angle-down"
                            aria-hidden="true"
                        ></i>
                        <i
                            v-if="opened && status === 'COMPLETED'"
                            class="fas fa-angle-up"
                            aria-hidden="true"
                        ></i>
                        <i
                            v-if="status !== 'COMPLETED'"
                            class="fas fa-spinner fetching-spinner"
                            aria-hidden="true"
                        ></i>
                    </span>
                </button>
            </div>
            <div class="dropdown-menu" id="dropdown-menu" role="menu">
                <div class="dropdown-content">
                    <div class="dropdown-lists">
                        <div class="couriers-section">
                            <span class="is-size-7 list-title">Couriers</span>
                            <hr class="title-list-divider" />
                            <div class="couriers-list">
                                <a
                                    href="#"
                                    v-for="courier in couriers"
                                    :class="{
                                        'dropdown-item': true,
                                        'is-active': courier.id === focusedCourier,
                                    }"
                                    :key="courier.id"
                                    @click="onCourierSelected(courier.id)"
                                >
                                    {{ courier.name }}
                                </a>
                            </div>
                        </div>
                        <div class="drivers-divider"></div>
                        <div class="drivers-section">
                            <span class="is-size-7 list-title"
                                >Drivers for {{ focusedCourierName }}</span
                            >
                            <hr class="title-list-divider" />
                            <div class="drivers-list">
                                <a
                                    href="#"
                                    v-for="driver in drivers"
                                    class="drivers-list-name"
                                    :class="{
                                        'dropdown-item': true,
                                        'is-active': driver.id === selectedDriverId,
                                    }"
                                    :key="driver.id"
                                    @click="onDriverSelected(focusedCourier, driver.id)"
                                >
                                    {{ driver.name }}
                                </a>
                            </div>
                        </div>
                    </div>
                    <div>
                        <a
                            class="button clear-button is-small"
                            @click="clearSelection"
                            :disabled="selectedDriverId === null"
                        >
                            <span class="icon">
                                <i class="is-medium fas fa-times-circle clear-icon"></i>
                                Clear Selection
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Webapi } from '@/Webapi'

const driverCourierSorter = (driverCourier1, driverCourier2) =>
    driverCourier1.name.localeCompare(driverCourier2.name)

export default {
    name: 'DriverSelector',
    components: {},
    props: {
        selectedCourierId: Number,
        selectedDriverId: Number,
        onDriverSelected: Function, // (number, number)
    },
    data: () => ({
        focusedCourier: null,
        opened: false,
        courierDrivers: [],
        status: 'PRE',
    }),
    computed: {
        focusedCourierName() {
            if (this.focusedCourier === null) {
                return ''
            }
            return this.couriers.find((courier) => courier.id === this.focusedCourier).name
        },
        selectedCourierName() {
            if (this.$props.selectedCourierId === null) {
                return ''
            }
            return this.couriers.find((courier) => courier.id === this.$props.selectedCourierId)
                .name
        },
        driverName() {
            if (this.$props.selectedDriverId === null) {
                return ''
            }

            return this.courierDrivers
                .filter(
                    (courierDriver) => courierDriver.courier.id === this.$props.selectedCourierId,
                )
                .flatMap((courierDriver) => courierDriver.drivers)
                .find((driver) => driver.id === this.$props.selectedDriverId).name
        },
        drivers() {
            if (this.focusedCourier === null) {
                return []
            }
            return this.courierDrivers
                .find((courierDriver) => courierDriver.courier.id === this.focusedCourier)
                .drivers.sort(driverCourierSorter)
        },
        couriers() {
            return this.courierDrivers
                .map((courierDrivers) => courierDrivers.courier)
                .sort(driverCourierSorter)
        },
    },
    methods: {
        toggle() {
            this.opened = !this.opened
        },
        onCourierSelected(courierId) {
            this.focusedCourier = courierId
        },
        clearSelection() {
            this.onDriverSelected(null, null)
        },
    },
    beforeMount() {
        this.status = 'IN_PROGRESS'
        Webapi()
            .courierDrivers()
            .then((response) => {
                if (response.status === 'COMPLETED') {
                    this.courierDrivers = response.payload
                }
                this.status = response.status
            })
    },
}
</script>
<style lang="scss" scoped>
.backdrop {
    position: fixed;
    z-index: 10;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}
.dropdown {
    width: 100%;
}
.dropdown-trigger {
    width: 100%;
}
.dropdown-lists {
    display: flex;
}
.clear-button {
    margin-top: 10px;
    margin-left: 5px;
    width: calc(100% - 10px);
}
.clear-icon {
    font-size: 16px;
    color: slategray;
    margin-right: 5px;
}
.dropdown-menu {
    width: 100%;
    z-index: 30;
}
.dropdown-button {
    width: 100%;
    display: flex;
    justify-content: space-between;
}
.selected-driver {
    display: flex;
    margin-top: -5px;
}
.selected-driver-label {
    color: slategrey;
    font-size: 10px;
    margin-bottom: -3px;
}
.selected-driver-part {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.selected-courier-value {
    width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
}
.drivers-divider {
    flex-shrink: 0;
    align-self: stretch;
    height: 100px;
    width: 1px;
    margin-top: -7px;
    margin-bottom: -8px;
    background-color: whitesmoke;
}
.list-title {
    padding-left: 10px;
}
.title-list-divider {
    margin-top: 2px;
    margin-bottom: 2px;
}
.couriers-section {
    flex: 1;
}
.drivers-section {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
}
.couriers-list,
.drivers-list {
    height: 300px;
    overflow-y: auto;
}
.drivers-list-name {
    width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: start;
    padding-right: 10px;
}
.fetching-spinner {
    animation: spin 1s linear infinite;
}
@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}
</style>
